import { defineComponent as A, useAttrs as D, useCssModule as M, useSlots as V, inject as j, ref as P, computed as C, watch as q, createElementBlock as x, openBlock as r, Fragment as z, createElementVNode as F, createCommentVNode as w, mergeProps as J, unref as e, createBlock as k, renderSlot as E, normalizeClass as c, withCtx as _, createVNode as b } from "vue";
import L from "lodash-es/uniqueId";
import { t as m } from "./locale.js";
import O from "./Checkbox.js";
import { _ as U } from "./ChevronToggle.vue_vue_type_script_setup_true_lang-Ce_qOXfR.js";
import { _ as G } from "./Expand.vue_vue_type_script_setup_true_lang-CiONJfAp.js";
import "lodash-es/cloneDeep";
import "./DataView.keys-aSOnA4AD.js";
import "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import y from "./TableCell.js";
import { T as H } from "./Table.keys-LHQf6FEH.js";
import { _ as K } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Q = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "TableRow",
  props: {
    hideExpansionDivider: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 },
    isSelected: { type: Boolean, default: !1 },
    isSelectDisabled: { type: Boolean, default: !1 },
    accentColor: { default: void 0 }
  },
  emits: ["update:isSelected", "update:isExpanded"],
  setup(S, { emit: T }) {
    const t = S, f = T, B = D(), o = M(), i = V(), h = j(H.key);
    if (!h)
      throw new Error("TableRow must be used within a Table component");
    const { hasActions: R, hasCustomExpandToggle: g, isExpandable: $, isSelectable: u, layout: d } = h, l = P(t.isExpanded), n = C(() => $.value && !!i.expansion), I = C(() => {
      var s;
      let a = ((s = i.default) == null ? void 0 : s.call(i, { toggleExpand: p }).length) ?? 0;
      return u.value && (a += 1), n.value && !g.value && (a += 1), a;
    }), v = L("table-row-");
    function p(a) {
      if (!n.value)
        throw new Error("Cannot call `toggleExpand` on a non-expandable row. Provide an `expansion` slot.");
      const s = typeof a == "boolean" ? a : !l.value;
      l.value = s, f("update:isExpanded", s);
    }
    return q(
      () => t.isExpanded,
      () => p(t.isExpanded)
    ), (a, s) => (r(), x(z, null, [
      F("tr", J({
        class: ["stash-table-row", [
          e(o).root,
          e(o)[`layout--${e(d)}`],
          {
            [e(o)["is-expandable"]]: n.value,
            [e(o)["is-expanded"]]: l.value,
            [e(o)["root--hidden-divider"]]: a.hideExpansionDivider,
            "tw-p-gutter": e(d) === "stack",
            "tw-mb-6 tw-shadow lg:tw-mb-0 lg:tw-shadow-none": e(d) === "stack" && !n.value,
            "tw-pt-[60px]": e(R) && e(d) === "stack" && !e(u),
            "stash-table-row--accent": t.accentColor,
            "tw-relative": t.accentColor
          }
        ]],
        "data-test": "stash-table-row"
      }, e(B)), [
        e(u) ? (r(), k(y, {
          key: 0,
          "is-control": "",
          class: c(["stash-table-row__selection-cell tw-min-w-[48px]", e(o)["row-control-cell"]]),
          "data-test": "stash-table-row|selection-cell"
        }, {
          default: _(() => [
            b(O, {
              class: c(e(o)["row-selection-checkbox"]),
              checked: t.isSelected,
              disabled: t.isSelectDisabled,
              title: e(m)("ll.select.self"),
              "onUpdate:checked": s[0] || (s[0] = (N) => f("update:isSelected", N))
            }, null, 8, ["class", "checked", "disabled", "title"])
          ]),
          _: 1
        }, 8, ["class"])) : w("", !0),
        n.value && !e(g) ? (r(), k(y, {
          key: 1,
          class: c(["stash-table-row__toggle-expansion-cell tw-px-0", e(o)["row-control-cell"]]),
          "data-test": "stash-table-row|custom-expansion-cell",
          "is-control": ""
        }, {
          default: _(() => [
            b(U, {
              "aria-controls": e(v),
              "aria-label": l.value ? e(m)("ll.table.collapseRow") : e(m)("ll.table.expandRow"),
              direction: l.value ? "up" : "down",
              "is-expanded": l.value,
              onClick: p
            }, null, 8, ["aria-controls", "aria-label", "direction", "is-expanded"])
          ]),
          _: 1
        }, 8, ["class"])) : w("", !0),
        E(a.$slots, "default", {
          isRowExpanded: l.value,
          toggleExpand: p
        }),
        t.accentColor ? (r(), x("div", {
          key: 2,
          "data-test": "stash-table-row|accent",
          class: c({
            "tw-absolute": t.accentColor,
            [`tw-bg-${t.accentColor}`]: t.accentColor,
            "tw-block": t.accentColor,
            "tw-h-full": t.accentColor,
            "tw-w-1": t.accentColor,
            "tw-top-0": t.accentColor,
            "tw-left-0": t.accentColor
          })
        }, null, 2)) : w("", !0)
      ], 16),
      n.value ? (r(), x("tr", {
        key: 0,
        class: c(["stash-table-row stash-table-row--expandable", e(o)["row-expansion"]]),
        "data-test": "stash-table-row|expansion-row"
      }, [
        b(G, {
          is: "td",
          id: e(v),
          class: c(["tw-border-none tw-bg-white tw-px-3 tw-py-0", e(o)["row-expansion-content"]]),
          "data-test": "stash-table-row|expansion-cell",
          colspan: I.value,
          "is-expanded": l.value
        }, {
          default: _(() => [
            E(a.$slots, "expansion")
          ]),
          _: 3
        }, 8, ["id", "class", "colspan", "is-expanded"])
      ], 2)) : w("", !0)
    ], 64));
  }
}), W = "_root_ngiw1_2", X = {
  root: W,
  "is-expandable": "_is-expandable_ngiw1_9",
  "root--hidden-divider": "_root--hidden-divider_ngiw1_14",
  "is-expanded": "_is-expanded_ngiw1_14",
  "layout--scroll": "_layout--scroll_ngiw1_22",
  "layout--stack": "_layout--stack_ngiw1_36",
  "row-selection-checkbox": "_row-selection-checkbox_ngiw1_56",
  "row-control-cell": "_row-control-cell_ngiw1_62",
  "row-expansion-content": "_row-expansion-content_ngiw1_73",
  "row-expansion": "_row-expansion_ngiw1_73"
}, Y = {
  $style: X
}, pe = /* @__PURE__ */ K(Q, [["__cssModules", Y]]);
export {
  pe as default
};
//# sourceMappingURL=TableRow.js.map
